import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MixpanelEvents } from '../../models/mixpanelEvents';
import { MixpanelService } from '../../services/mixpanel.service';

import { SHARED_MODULES } from '../../../shared.';
import { PhButtonComponent } from '../ph-button/ph-button.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

@Component({
    selector: 'app-tariff-comparison',
    templateUrl: './tariff-comparison.component.html',
    styleUrls: ['./tariff-comparison.component.scss'],
	imports: [SHARED_MODULES, PhButtonComponent, PhIconComponent],
    standalone: true
})
export class TariffComparisonComponent implements OnInit {

	public info: Array<{ section: string, features: Array<any> }> = [
		{
			section: 'COMMON.ENTITY.STORE_PLANS',
			features: [
				{ text: 'FEATURE_STORE_PLAN_CREATION', starter: 'TARIFF_COMPARISON.UP_TO', starterNumber: 5, pro: 'TARIFF_COMPARISON.UP_TO', proNumber: 30, enterprise: 'UNLIMITED' },
				{ text: 'FEATURE_PLANOGRAM_LIBRARY_CREATION', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_DOWNLOADING_PLAN_AUTOCAD', starter: 'icon', pro: 'icon', enterprise: 'icon' }
			]
		},
		{
			section: 'COMMON.ENTITY.PLANOGRAMS',
			features: [
				{ text: 'FEATURE_PLANOGRAM_CREATION', starter: 'TARIFF_COMPARISON.UP_TO', starterNumber: 100, pro: 'TARIFF_COMPARISON.UP_TO', proNumber: 1000, enterprise: 'UNLIMITED' },
				{ text: 'FEATURE_SIMPLIFIED_PRODUCT_AUTO_LAYOUT', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_UPLOADING_XLS', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_PRODUCT_AUTO_LAYOUT', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_PLANOGRAM_RECOVERY', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_LAYOUT_MIRRORING', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_BLOCK_PLANOGRAMS_CREATION', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_PRODUCTS_HIGHLIGHT', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_COPYING_PLANOGRAMS', starter: '', pro: 'icon', enterprise: 'icon', proNew: true },
				{ text: 'TARIFF_COMPARISON.COPYING_WITH_EXTENSION', starter: '', pro: '', enterprise: 'icon' },
				{ text: 'FEATURE_GROUP_PRODUCTS_ROTATION', starter: '', pro: '', enterprise: 'icon' },
				{ text: 'FEATURE_LAYOUT_RULES', starter: '', pro: '', enterprise: 'icon' }
			]
		},
		{
			section: 'COMMON.ENTITY.EQUIPMENT',
			features: [
				{ text: 'FEATURE_EQUIPMENT_CREATION', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_EQUIPMENT_TEMPLATES', starter: 'icon', pro: 'icon', enterprise: 'icon' }
			]
		},
		{
			section: 'PRODUCTS',
			features: [
				{ text: 'TARIFF_COMPARISON.SKU_NUMBER', starter: 'TARIFF_COMPARISON.UP_TO', starterNumber: 1500, pro: 'TARIFF_COMPARISON.UP_TO', proNumber: 3000, enterprise: 'UNLIMITED' },
				{ text: 'FEATURE_CHANGES_HISTORY_AND_RESTORE', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_LISTEX_UPDATE_PARAMETERS', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_UPDATE_PARAMETERS_DATABASE', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_ASSORTMENT_TYPES', starter: '', pro: '', enterprise: 'icon' },
				{ text: 'FEATURE_PRODUCT_HOLES', starter: '', pro: '', enterprise: 'icon' },
				{ text: 'FEATURE_PH_SIZE_APP', starter: '', pro: '', enterprise: 'icon' }
			]
		},
		{
			section: 'FEATURE_GROUP_SENDING_AND_CONTROL',
			features: [
				{ text: 'FEATURE_SENDING_PLANOGRAM', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_DEADLINE_SETTING', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_TIME_TRACKER', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_CONTROL_PHOTO_REPORTS', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_HISTORY_PLANOGRAM_EXECUTION', starter: '', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_PH_LAYOUT_APP', starter: '', pro: '', enterprise: 'icon' }
			]
		},
		{
			section: 'ANALYTICS',
			features: [
				{ text: 'FEATURE_ANLYTICS_AND_PLAN_COMPARISON', starter: '', pro: '', enterprise: 'icon' },
				{ text: 'FEATURE_ANLYTICS_AND_PLANOGRAM_COMPARISON', starter: '', pro: '', enterprise: 'icon' },
				{ text: 'FEATURE_PREVIOUS_VERSION_PLANOGRAM_ANALYTICS', starter: '', pro: '', enterprise: 'icon' },
				{ text: 'FEATURE_CHAIN_SUMMARY_REPORTS', starter: '', pro: '', enterprise: 'icon' }
			]
		},
		{
			section: 'DATA',
			features: [
				{ text: 'FEATURE_EVERYDAY_DATA_UPDATE', starter: '', pro: 'icon', enterprise: 'icon' },
				{
					text: 'FEATURE_DOWNLOADABLE_DATA',
					starter: 'STORES_CATEGORY_BRANDS_PRODUCTS',
					pro: 'STORES_CATEGORY_BRANDS_PRODUCTS_SUPPLIERS_STOCKS_PRICES',
					enterprise: 'DOWNLOADABLE_DATA_ENTERPRISE'
				},
				{
					text: 'FEATURE_UPLOADING_DATA_METHOD',
					starter: 'UPLOADING_DATA_METHOD_STARTER',
					pro: 'UPLOADING_DATA_METHOD_PRO',
					enterprise: 'UPLOADING_DATA_METHOD_ENTERPRISE'
				}
			]
		},
		{
			section: 'SUPPORT_GROUP',
			features: [
				{ text: 'FEATURE_ACCESS_KNOWLEDGE_BASE', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_NEWSLETTERS', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_DAILY_SUPPORT', starter: 'icon', pro: 'icon', enterprise: 'icon' },
				{ text: 'FEATURE_UPLOADING_DATA_SUPPORT', starter: '', pro: '', enterprise: 'icon' }
			]
		}
	]

	@ViewChild('container') container: ElementRef;

	constructor(private mixPanelService: MixpanelService) {}

	public ngOnInit() {
		this.mixPanelService.trackPage(MixpanelEvents.TariffComparison);
	}

	contactManager() {
		window.$crisp.push(['do', 'chat:open']);
	}
}